import { cn } from '@commenda/utils';
import * as React from 'react';
import { InputErrorMessage } from '../InputErrorMessage';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <div className="w-full flex flex-col gap-2">
        <textarea
          className={cn(
            'flex min-h-32 w-full box-border rounded-md px-xl py-2.5 bg-bg-primary text-text-primary txt-small-regular placeholder:text-text-placeholder ring-0 transition-colors',
            'disabled:cursor-not-allowed disabled:bg-bg-disabled-subtle disabled:text-text-disabled disabled:resize-none appearance-none focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[var(--color-bg-brand-hover)]',
            'border disabled:border-border-disabled disabled:pointer-events-none',
            error
              ? 'border-border-error hover:border-border-error focus-visible:border-border-error-hover'
              : 'border-border-primary hover:border-border-primary-hover focus-visible:border-fg-brand',
            className
          )}
          ref={ref}
          {...props}
        />
        {error ? <InputErrorMessage message={error} /> : null}
      </div>
    );
  }
);
Textarea.displayName = 'Textarea';

export default Textarea;
